import { render, staticRenderFns } from "./MerchantInput.vue?vue&type=template&id=742e6a10&scoped=true"
import script from "./MerchantInput.vue?vue&type=script&lang=js"
export * from "./MerchantInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742e6a10",
  null
  
)

export default component.exports